import { timezones } from 'src/directories';

const MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

export const formatDateToString = (dateStr: string): string => {
  const [year, month, day] = dateStr.slice(0, 10).split('-').map(Number);
  const formattedDay = day.toString().padStart(2, '0');
  const formattedMonth = MONTHS[month - 1];
  return `${formattedDay} ${formattedMonth} ${year}`;
};

export const formatDateYYYYMMDD = (inputDate: Date | string): string => {
  const date = new Date(inputDate);
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  return `${date.getFullYear()}-${month}-${day}`;
};

export const getFormattedOffset = () => {
  const offset = new Date().getTimezoneOffset();
  const hours = Math.floor(Math.abs(offset) / 60);
  const minutes = Math.abs(offset) % 60;
  const sign = offset <= 0 ? '+' : '-';
  return `${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};

export const parseDateInLocalTimezone = (dateString: string): Date => {
  const [year, month, day] = dateString.slice(0, 10).split('-').map(Number);
  return new Date(year, month - 1, day);
};

export const getLocalTime = (date: string, utcOffset: string): string => {
  const utcDate = new Date(date);

  if (!utcOffset.startsWith('+') && !utcOffset.startsWith('-')) {
    utcOffset = '+' + utcOffset;
  }

  const offsetMatch = utcOffset.match(/([+-]?)(\d{2}):(\d{2}):(\d{2})/);
  if (!offsetMatch) throw new Error('Invalid UTC offset format');

  const offsetSign = offsetMatch[1] === '-' ? -1 : 1;
  const offsetHours = parseInt(offsetMatch[2]) * offsetSign;
  const offsetMinutes = parseInt(offsetMatch[3]) * offsetSign;

  const localDate = new Date(utcDate.getTime());
  localDate.setUTCHours(localDate.getUTCHours() + offsetHours);
  localDate.setUTCMinutes(localDate.getUTCMinutes() + offsetMinutes);

  return localDate.toISOString().slice(0, 19);
};

export const mapTimezone = (time: string) => {
  const match = time.match(/^([+-]?)(\d{2}):(\d{2}):\d{2}$/);
  if (!match) return { value: '', label: '' };
  const [, sign, hours, minutes] = match;
  const formattedTime = `${sign || '+'}${hours}:${minutes}`;
  return timezones.find((tz) => tz.value === formattedTime) || { value: '', label: '' };
};
